import cn from 'classnames';
import { ReactElement } from 'react';
import type { TextProps } from './Text.types';

import s from './Text.module.css';

const Text = ({
  children,
  weight = 'regular',
  variant = 'body',
  lineHeight = 'normal',
  lineThrough = false,
  className,
  color = 'neutral-900',
  component = 'p',
  centerText = false,
  spacing,
  inheritColor = false,
}: TextProps): ReactElement => {
  const Tag = component as keyof React.JSX.IntrinsicElements;
  const classElement = cn(
    s.text,
    className,
    s[`lineHeight-${lineHeight}`],
    s[`font-${variant}`],
    s[`weight-${weight}`],
    {
      [`spacing-${spacing}`]: !!spacing,
      [s.strikeThrough]: lineThrough,
      [s.centerText]: centerText,
    },
  );

  return (
    <Tag
      className={classElement}
      style={{ color: !inheritColor ? `var(--colors-${color})` : undefined }}
    >
      {children}
    </Tag>
  );
};

export default Text;
